export const getAppTimezone = () => {
  return localStorage.getItem('appTimezone') || 'America/Mexico_City';
};

export const formatDateTimeByTimezone = (value, fallback = '-') => {
  if (!value) return fallback;
  const date = new Date(value);
  const tz = getAppTimezone();
  return new Intl.DateTimeFormat('es-MX', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(date);
};
